export const STRINGS = {
  en: {
    eyebrow: "Los Cabos · Meetings & MICE",
    pageTitle: "Beyond the Meeting Room",
    pageIntro:
      "The southern tip of Baja lives at its own pace — where the desert meets two seas, and every event finds its own horizon. Ask our concierge anything about venues, hotels, capacities and experiences from the official Meeting Planner Guide.",
    widgetTitle: "Meet Los Cabos' First Events Industry Concierge",
    widgetSubtitle: "Your MICE guide to Los Cabos",
    welcomeTitle: "Welcome to Los Cabos.",
    welcomeBody:
      "I'm your Los Cabos Meetings concierge — here to help you shape unforgettable events at Land's End. Ask me about venues, hotels, ballrooms, capacities, group activities, gastronomy or the destination itself.",
    welcomeCta: "Where should we start?",
    inputPlaceholder: "Ask about venues, capacities, activities…",
    send: "Send",
    typing: "Cabo Concierge is composing",
    langLabel: "EN",
    poweredBy: "Powered by the official Los Cabos Meeting Planner Guide",
    online: "Live",
    disclaimer:
      "Answers are grounded in the official Los Cabos Meeting Planner Guide.",
    suggestions: [
      "I'm planning a 300-guest corporate incentive",
      "Help me scope a product launch for 150",
      "Beachfront wedding, ~120 guests, March",
      "Executive retreat with golf and spa",
      "Tell me about the 0% VAT tax benefit",
    ],
  },
  es: {
    eyebrow: "Los Cabos · Reuniones y MICE",
    pageTitle: "Más allá de la sala de juntas",
    pageIntro:
      "En la punta sur de Baja, dos mares se encuentran con el desierto y cada evento halla su propio horizonte. Pregúntale a nuestro concierge sobre venues, hoteles, capacidades y experiencias, directo de la Guía Oficial de Planeación de Reuniones.",
    widgetTitle: "Conoce al primer Concierge de la Industria de Eventos de Los Cabos",
    widgetSubtitle: "Tu guía MICE en Los Cabos",
    welcomeTitle: "Bienvenido a Los Cabos.",
    welcomeBody:
      "Soy tu concierge de Reuniones de Los Cabos, aquí para ayudarte a crear eventos inolvidables en Land's End. Pregúntame por venues, hoteles, salones, capacidades, actividades de grupo, gastronomía o el destino en sí.",
    welcomeCta: "¿Por dónde empezamos?",
    inputPlaceholder: "Pregunta por venues, capacidades, actividades…",
    send: "Enviar",
    typing: "Cabo Concierge está redactando",
    langLabel: "ES",
    poweredBy: "Impulsado por la Guía Oficial de Planeación de Reuniones de Los Cabos",
    online: "En vivo",
    disclaimer:
      "Las respuestas se basan en la Guía Oficial de Planeación de Reuniones de Los Cabos.",
    suggestions: [
      "Estoy planeando un incentivo corporativo de 300 personas",
      "Ayúdame a diseñar un lanzamiento de producto para 150",
      "Boda frente al mar, ~120 invitados, en marzo",
      "Retiro ejecutivo con golf y spa",
      "Cuéntame del beneficio fiscal 0% IVA",
    ],
  },
};
